import React from "react";

import { useStrainPageContext } from "@/context/StrainPageContext";

import Section from "../Section";
import StrainGrowInfoRow from "./StrainGrowInfoRow";

const StrainGrowInfo = () => {
  const { strain } = useStrainPageContext();

  const { growInfo, name, phenotype } = strain;

  if (!strain) {
    return <></>;
  }

  const hasGrowInfo =
    growInfo?.averageYield &&
    growInfo?.difficulty &&
    (growInfo?.floweringDays || 0) > 0 &&
    growInfo?.height;

  const floweringWeeks = (growInfo?.floweringDays || 0) / 7;

  return (
    <Section
      className="w-full"
      title={`${name} grow information`}
      id="strain-grow-info-section"
    >
      {hasGrowInfo ? (
        <div className="w-full mt-sm pb-4">
          <StrainGrowInfoRow
            title="Type"
            options={[
              { selected: phenotype === "Indica", title: "indica" },
              { selected: phenotype === "Sativa", title: "sativa" },
              { selected: phenotype === "Hybrid", title: "hybrid" },
            ]}
          />
          <StrainGrowInfoRow
            title="Difficulty"
            options={[
              { selected: growInfo?.difficulty === "Easy", title: "easy" },
              {
                selected: growInfo?.difficulty === "Moderate",
                title: "moderate",
              },
              {
                selected: growInfo?.difficulty === "Difficult",
                title: "difficult",
              },
            ]}
          />
          <StrainGrowInfoRow
            title="Height"
            options={[
              { selected: growInfo?.height === "Short", title: "short" },
              {
                selected: growInfo?.height === "Medium",
                title: "average",
              },
              { selected: growInfo?.height === "Tall", title: "tall" },
            ]}
          />
          <StrainGrowInfoRow
            title="Yield"
            options={[
              {
                selected: growInfo?.averageYield === "Low",
                title: "low",
              },
              {
                selected: growInfo?.averageYield === "Medium",
                title: "medium",
              },
              { selected: growInfo?.averageYield === "High", title: "high" },
            ]}
          />
          <StrainGrowInfoRow
            title="Flowering (weeks)"
            options={[
              {
                selected: 7 <= floweringWeeks && floweringWeeks < 9.5,
                title: "7 - 9",
              },
              {
                selected: floweringWeeks >= 9.5 && floweringWeeks < 12,
                title: "10 - 12",
              },
              { selected: floweringWeeks >= 12, title: "&gt; 12" },
            ]}
          />
        </div>
      ) : (
        <></>
      )}

      {growInfo?.growNotes && (
        <div
          data-testid="grow-notes"
          className="flex flex-col gap-2 [&>ul]:list-disc [&>ul]:pl-lg [&>ul>li]:pb-2 [&>ul>li>a]:text-green [&>ul>li>a]:underline [&>ol]:list-decimal [&>ol]:pl-lg [&>ol>li]:pb-2 [&>ol>li>a]:text-green [&>ol>li>a]:underline"
          dangerouslySetInnerHTML={{ __html: growInfo.growNotes }}
        ></div>
      )}
    </Section>
  );
};

export default StrainGrowInfo;
